module.exports = __webpack_public_path__ + "img/yxkdiag1.5518239b.svg";